module.exports = __webpack_public_path__ + "static/media/cancelledimg.14e23891.png";